import { cn } from '@/lib/utils';
import { SkeletonLines } from '@/components/ui/skeleton';

export interface PdfFrameProps {
  /** Object URL of the PDF (see `usePdfObjectUrl` / `useBlobObjectUrl`). */
  src: string | null;
  title: string;
  loading?: boolean;
  error?: string | null;
  className?: string;
}

/** Inline PDF viewer (iframe on an object URL) with loading and error states. */
export function PdfFrame({ src, title, loading = false, error = null, className }: PdfFrameProps) {
  if (error) return <p className="text-sm text-destructive">Preview failed: {error}</p>;
  if (loading || !src) return <SkeletonLines lines={3} className={className} />;
  return (
    <iframe title={title} src={src} className={cn('h-[70vh] w-full rounded-md border bg-muted', className)} />
  );
}
